var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "11px",
    viewBox: "0 0 9 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C82372BD-4BE3-4699-9CE9-21A5CE82ED77") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-To-Do--Flagged-as-Important",
    transform: "translate(-851.000000, -161.000000)",
    fill: "#DBBC4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(851.247603, 161.156383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red-flag",
    transform: "translate(0.000000, 0.029750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84451782,0 C5.02759778,0 4.42875003,0.332399261 3.84958907,0.653868248 C3.31542065,0.950359612 2.81086445,1.2304248 2.15324341,1.2304248 C1.53159178,1.2304248 0.889330542,0.906207869 0.615212402,0.74951327 L0.615212402,0 L0,0 L0,10.499625 L0.615212402,10.499625 L0.615212402,6.36654605 C1.00031486,6.55250425 1.57114994,6.76733643 2.15324341,6.76733643 C2.97014294,6.76733643 3.56903171,6.43493716 4.14817216,6.11346818 C4.68234058,5.81697681 5.18691729,5.53691162 5.84451782,5.53691162 C6.6601049,5.53691162 7.51133329,6.09503231 7.51953612,6.10046669 L7.99776123,6.41929026 L7.99776123,0.758187765 C7.36522035,0.340745643 6.5931903,0 5.84451782,0 Z",
    id: "_x3C_Group_x3E__7_"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagYellow);
export default __webpack_public_path__ + "static/media/flag-yellow.8df982e22ce4993376b67239857637d1.svg";
export { ForwardRef as ReactComponent };